import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'


//put your own config from firebase project
var config = {
  apiKey: "AIzaSyAjHU2Q6DmHuYOyMHeLydxgc-tjJbZfTP8",
  authDomain: "mangoshop-4771b.firebaseapp.com",
  databaseURL: "https://mangoshop-4771b.firebaseio.com",
  projectId: "mangoshop-4771b",
  storageBucket: "mangoshop-4771b.appspot.com",
  messagingSenderId: "1072016577956",
  appId: "1:1072016577956:web:4cc13a92bd03749175dd31",
  measurementId: "G-PQWS24F38H"
};

  firebase.initializeApp(config);
  // firebase.firestore().settings( { timestampsInSnapshots : true } )

  export default firebase;